var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8384 8.34174C11.7362 8.23843 11.5966 8.18011 11.4514 8.18011C11.3057 8.18011 11.1667 8.23842 11.0639 8.34174L9.27006 10.1422V8.72893C9.27006 6.41393 8.35088 4.19359 6.71449 2.55633C5.07857 0.919586 2.85934 0 0.544971 0C0.243857 0 0 0.243979 0 0.545244C0 0.846509 0.243857 1.091 0.544971 1.091C2.56998 1.091 4.51162 1.89555 5.94351 3.32823C7.37501 4.76044 8.17962 6.70345 8.17962 8.72894V10.1422L6.38573 8.34176C6.17204 8.12796 5.82492 8.12796 5.61122 8.34176C5.39702 8.55555 5.39702 8.90233 5.61122 9.11666L8.33758 11.8444C8.38921 11.894 8.45056 11.9329 8.51753 11.959C8.65045 12.0137 8.79921 12.0137 8.93214 11.959C8.99911 11.9329 9.05995 11.894 9.11209 11.8444L11.8384 9.11666C11.9417 9.01385 12 8.87472 12 8.72896C12 8.58369 11.9417 8.44403 11.8384 8.34174Z",
    fill: "#586B74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down-icon.bdb1c7372d50a0c30a9b259769810b51.svg";
export { ForwardRef as ReactComponent };